import Axios from "axios";
import ApiUtils from "../utils/api_utils";

const CommonSM = {
  state: {
    reports: [],
  },
  reducers: {
    setCommonState(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: (dispatch) => ({
    /**
     * get list report
     */
    async getReport(_payload, rootState) {
      await Axios.get(
        `https://${ApiUtils.authority}/feeds/api/report-reason/?pagination=false`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then((response) => {
          dispatch.CommonSM.setCommonState({
            ...rootState.CommonSM,
            reports: response.data,
          });
        })
        .catch(function () {});
    },
    async postReport(payload, rootState) {
      let result;
      await Axios.post(
        `https://${ApiUtils.authority}/feeds/api/report/`,
        payload,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then((response) => {
          result = {
            data: response.data,
            status: 200,
            message: "success",
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
  }),
};

export default CommonSM;
